import { NumberFormatter, Table } from "@mantine/core";

export default function LedgerTable({ ledger }) {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Date</Table.Th>
          <Table.Th ta="right">Credits</Table.Th>
          <Table.Th>Note</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {ledger?.map((p) => (
          <Table.Tr key={p.id}>
            <Table.Td>{p.idCreated}</Table.Td>
            <Table.Td ta="right">
              <NumberFormatter thousandSeparator value={p.delta} />
            </Table.Td>
            <Table.Td>{p.notes}</Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}
